module.exports = __webpack_public_path__ + "img/ian.891167c4.jpg";